export default {
  data() {
    return {
      codeTypes: ['Single Code', 'Many Random Codes'],
      couponTypes: ['Free Trial ( No Card Required )', 'Membership Credit'],
      campaigns: [],
      couponType: null,
      codeType: null,
      campaign: null,
      id: null,
      code: null,
      copies: null,
      redeem_by: null,
      max_redemptions: 1,
      trial_length_days: null,
      membership_credit_amount: null,
      expires: false,
      isPrivate: (Kadenze.isKannu),
      coupon: null,
    };
  },
  computed: {
    codeTypeIndex() {
      return _.indexOf(this.codeTypes, this.codeType);
    },
    couponTypeIndex() {
      return _.indexOf(this.couponTypes, this.couponType);
    },
    stringRedeemBy() {
      return moment(this.redeem_by).toString();
    },
    canSubmit() {
      if ( this.isPrivate ) {
        return this.codeTypeIndex != -1;
      }

      return (
        ( this.couponTypeIndex !== -1 &&
           this.codeTypeIndex !== -1 ) &&
        (!_.isEmpty(this.membership_credit_amount) ||
          !_.isEmpty(this.trial_length_days))

      );
    },
    showCouponCodeType() {
      return (( this.codeTypeIndex != -1 ) || this.isPrivate);
    }
  },
  methods: {
    bindData(data) {
      this.campaigns = data.campaign;
      this.coupon = data.coupon;
    },
    create() {
      const url = Kadenze.Routes.admin_membership_coupons_path();
      new Kadenze.AjaxRequest({
        url,
        method: 'POST',
        format: 'JSON',
        data: {
          trial_length_days: this.trial_length_days,
          coupon_campaign_id: this.campaign,
          code: this.code,
          credit_amount: this.membership_credit_amount,
          redeem_by: this.stringRedeemBy,
          max_redemptions: this.max_redemptions,
          copies: this.copies
        }
      }).success(() => {
        new Kadenze.Notice.success({
          message: Kadenze.I18n.t('coupons.create_coupon_message')
        });
        window.location = this.campaign ?
          Kadenze.Routes.admin_coupon_campaign_path(this.campaign) :
          Kadenze.Routes.admin_membership_coupons_path();
      }).error((resp) => {
        console.warn(resp);
      });
    },
    edit() {
      const url = Kadenze.Routes.admin_membership_coupon_path(this.coupon);
      new Kadenze.AjaxRequest({
        url,
        method: 'PUT',
        format: 'JSON',
        data: {
          coupon_campaign_id: this.campaign,
          redeem_by: this.stringRedeemBy
        }
      }).success(() => {
        new Kadenze.Notice.success({
          message: Kadenze.I18n.t('coupons.update_coupon_message')
        });
        window.location = Kadenze.Routes.admin_membership_coupons_path();
      }).error((resp) => {
        console.warn(resp);
      });
    },
  },
  mounted() {
    if(this.coupon){
      const { max_redemptions,code, coupon_campaign_id, valid, redeem_by   } = this.coupon;
      this.max_redemptions = max_redemptions;
      this.code = code;
      this.campaign = coupon_campaign_id;
      this.expires = valid;
      this.redeem_by = moment(redeem_by).toString();
    }
    this.$nextTick(() => {
      (new Kadenze.KdForms()).init();
    });
  }
};
